import { createActionWithPayload } from "store/helpers";
import { ActionTypes, IVersaoApp } from "./types";

export const set = createActionWithPayload<IVersaoApp>(ActionTypes.SET);
